export const pages = {
  'cart': 'cart',
  'checkout': 'checkout'
}